import {makeAutoObservable} from "mobx";
import {displayErrorDialogPrompt} from "../common/util/errror/log.util";
import {getDayPath, getDefaultContentUrl} from "./ContentStore";
import {langTypes, multiLangType} from "../common/enums/ExcelEnum";
import {LangType, TranslationLangType} from "../common/enums/ContentEnum";

const logPrefix  = "[EvenStepTwoStore]"
export default class EvenStepTwoStore {

    constructor(props) {
        this.contentRepository = props.contentRepository;
        this.contentStore = props.contentStore;
        this.dialogStore = props.dialogStore;
        this.commonStore = props.commonStore;

        this.contentTapIndex = 0;
        this.contentList = [];
        this.selectedContent = [];
        this.translationContents = {};
        this.requestTranslations = [];
        this.readyToSaveStep = false;

        makeAutoObservable(this);
    }

    initEvenStepTwoContent = () => {
        this.contentList = [];
        this.selectedContent = [];
        this.contentTapIndex = 0;
        this.translationContents = {};
        this.requestTranslations = [];
    }

    setStepValue = (step) => {
        this.stepValue = step;
    }

    setDayValue = (day) => {
        this.dayValue = day;
    }

    setContentTapIndex = (index) => {
        this.contentTapIndex = index;
        this.setSelectedContent();
    };

    openErrorDialog = (info) => {
        if (this?.dialogStore) {
            this.dialogStore.openErrorDialog(info)
        }
    }


    setSelectedContent = () => {
        this.selectedContent = this.getSelectedContent(this.getSelectedLangCode());
    }

    setTranslationContents = (translations) => {
        translations.sort((a, b) => multiLangType.indexOf(a.languageCode) - multiLangType.indexOf(b.languageCode)).forEach(content => {
            if (!this.translationContents[content.languageCode]) {
                this.translationContents[content.languageCode] = [];
            }
            this.translationContents[content.languageCode].push(content);
        });
    }

    setTranslateText = (text, index, lang) => {
        let translationContent = this.translationContents[lang].slice();
        translationContent[index].text = text;
        this.setTranslate(lang, index);
    }

    setTranslateDisplay = (isEnable, lang) => {
        let translationContent = this.translationContents[lang].slice();
        translationContent.forEach((c, index) => {
            c.enable = isEnable;
            this.setTranslate(lang, index);
        });
    }

    getAiTranslate = (lang) => {
        this.getSelectedContent(LangType.EN).forEach((c, i) => {
            this.contentStore.getGeneratedTranslate(lang, c.text, (translatedText) => this.setTranslateText(translatedText, i, lang));
        });
    }

    setTranslate = (lang, index) => {
        let translationContent = this.translationContents[lang].slice();
        const targetContent = translationContent[index];
        this.translationContents = {
            ...this.translationContents,
            [lang]: translationContent,
        };

        const contentIdx = this.requestTranslations.findIndex(r => r.id === targetContent.id);
        if (contentIdx === -1) {
            this.requestTranslations.push(targetContent);
        } else {
            this.requestTranslations[contentIdx] = targetContent;
        }
        this.contentStore.setReadyToSaveStep(this.isEvenStepTwoCompleted() && !!this.requestTranslations.length);
        this.readyToSaveStep = this.isEvenStepTwoCompleted() && !!this.requestTranslations.length;
    }

    getSelectedLangCode = () => {
        return langTypes[this.contentTapIndex];
    }

    getSelectedContent = (langeCode) => {
        return this.contentList.filter(content => content.languageCode === langeCode);
    }

    isEvenStepTwoCompleted = () => {
        let hasEmptyValues = false;

        for (const lang of Object.keys(TranslationLangType)) {
            if (this.translationContents[lang].some(content => content.text === '' || content.speakerName === '')) {
                hasEmptyValues = true;
                break;
            }
        }

        return !hasEmptyValues;
    }

    * getEvenStepTwoContent(step, day) {
        this.commonStore.setLoadingState();
        try {
            console.log(logPrefix, 'Start getEvenStepTwoContent.');
            const url = `${getDayPath(day)}/${getDefaultContentUrl(step, day)}/2`;
            const response = yield this.contentRepository.getContent(url);

            if (response.data !== null) {
                const { contents, translations } = response.data;
                this.contentList = contents;
                this.setTranslationContents(translations);
            }

            this.contentStore.setReadyToMoveExit(this.isEvenStepTwoCompleted());
            this.contentStore.setReadyToSaveStep(false);
            this.readyToSaveStep = false;
            this.setSelectedContent();
            console.log(logPrefix, 'Finished getEvenStepTwoContent.');
        } catch (e) {
            console.log(logPrefix, 'Failed getEvenStepTwoContent.');
            this.openErrorDialog({
                titleText: '컨텐츠 불러오기 오류',
                text: displayErrorDialogPrompt(e, '컨텐츠를 불러오는 도중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * modifyEvenStepTwoContent(step, day) {
        this.commonStore.setLoadingState('데이터를 저장하는 중입니다.');
        try {
            console.log(logPrefix, 'Start modifyEvenStepTwoContent.');
            const url = `${getDayPath(day)}/${getDefaultContentUrl(step, day)}/2`;
            console.log(logPrefix, 'modifyEvenStepTwoContent requestContents :', this.requestTranslations);
            yield this.contentRepository.putContent(url, this.requestTranslations);
            console.log(logPrefix, 'Finished modifyEvenStepTwoContent.');
            this.requestTranslations = [];
            this.contentStore.setReadyToSaveStep(false);
            this.readyToSaveStep = false;
            // this.openErrorDialog({
            //     titleText: '저장 성공',
            //     text: displayErrorDialogPrompt('',  '컨텐츠를 정상적으로 저장하였습니다.')
            // });
        } catch (e) {
            console.log(logPrefix, 'Failed modifyEvenStepTwoContent.');
            this.openErrorDialog({
                titleText: '대화문 번역 수정 오류',
                text: displayErrorDialogPrompt(e, '대화문 번역 수정 작업중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }

}

